import React from 'react';
import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { ProblemSection } from '../components/ProblemSection';
import { InnerTruthSection } from '../components/InnerTruthSection';
import { BonusesSection } from '../components/BonusesSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { BuySection } from '../components/BuySection';
import { Footer } from '../components/Footer';
import { useMetaPixel } from '../utils/pixel';
export function LandingPage() {
  // Initialize Meta Pixel and track PageView on mount
  useMetaPixel();
  return <div className="min-h-screen bg-black text-white font-sans selection:bg-amber-500/30" data-id="element-202">
      <Header data-id="element-203" />
      <main data-id="element-204">
        <Hero data-id="element-205" />
        <ProblemSection data-id="element-206" />
        <InnerTruthSection data-id="element-207" />
        <BonusesSection data-id="element-208" />
        <TestimonialsSection data-id="element-209" />
        <BuySection data-id="element-210" />
      </main>
      <Footer data-id="element-211" />
    </div>;
}